import * as $ from "jquery";
import * as moment from "moment";
import * as _ from 'lodash'

export interface IgsDateScope extends ng.IScope {
  igsDateOpens: string;
  igsIncludeTime: boolean;
  igsRanges: any;
  igsDateDrops: string;
  igsMaxDate: string;
  igsMinDate: string;
  igsReadOnly: boolean;
}

export class DateDirective implements ng.IDirective {
  public restrict = "A";
  public require = "ngModel";
  public scope = {
    igsDateOpens: "@?",
    igsIncludeTime: "=",
    igsDateDrops: "@?",
    igsMaxDate: "@?",
    igsMinDate: "@?",
    igsReadOnly: "=?"
  };

  public link = (
    $scope: IgsDateScope,
    $elem: ng.IAugmentedJQuery,
    $attrs: ng.IAttributes,
    $ngModelCtrl: ng.INgModelController
  ) => {
    var uniqueDatePickerAttribute = _.uniqueId("date-picker-");
    $elem.parent().attr(uniqueDatePickerAttribute, "");

    $elem.daterangepicker({
      singleDatePicker: true,
      autoUpdateInput: false,
      opens: $scope.igsDateOpens || "right",
      timePicker: $scope.igsIncludeTime,
      drops: $scope.igsDateDrops,
      maxDate: $scope.igsMaxDate,
      minDate: $scope.igsMinDate,
      parentEl: "[" + uniqueDatePickerAttribute + "]"
    });

    $("[" + uniqueDatePickerAttribute + "] .daterangepicker.single").css(
      "width",
      "273px"
    );

    $ngModelCtrl.$parsers.push(val => DateUtility.getDateFromString(val));
    $ngModelCtrl.$formatters.push(val =>
      DateUtility.getStringFromInput(val, $scope.igsIncludeTime)
    );

    $elem.on("cancel.daterangepicker", () => {
      var value = "";
      $elem.val(value);
      $ngModelCtrl.$setViewValue(value);
    });

    $elem.on("apply.daterangepicker", (ev, picker) => {
      var dateString = DateUtility.getStringFromDate(
        picker.startDate.toDate(),
        $scope.igsIncludeTime
      );
      $elem.val(dateString);
      $ngModelCtrl.$setViewValue(dateString);
    });

    $elem.on("blur", ev => {
      var date = DateUtility.getDateFromString($elem.val() as string);
      var dateString = DateUtility.getStringFromDate(
        date,
        $scope.igsIncludeTime
      );
      $elem.val(dateString);
      $ngModelCtrl.$setViewValue(dateString);
    });

    $elem.on("show.daterangepicker", ev => {
      if ($scope.igsReadOnly) {
        $elem
          .parent()
          .find(".daterangepicker")
          .first()
          .css("display", "none");
      }
    });
  };
}

class DateUtility {
  private static dateRegex = /^((?:1[0-2])|(?:0?[0-9]))\/((?:[0-2]?[0-9])|(?:3[0-1]))\/(\d{2}(?:\d{2})?)(?: ((?:1[0-2])|(?:0?[0-9])):([0-5][0-9]) ((?:AM)|(?:PM)))?$/;
  private static dateTimeOnlyRegex = /^((?:1[0-2])|(?:0?[0-9]))\/((?:[0-2]?[0-9])|(?:3[0-1]))\/(\d{2}(?:\d{2})?)(?: ((?:1[0-2])|(?:0?[0-9])):([0-5][0-9]) ((?:AM)|(?:PM)))$/;
  private static dateOnlyRegex = /^((?:1[0-2])|(?:0?[0-9]))\/((?:[0-2]?[0-9])|(?:3[0-1]))\/(\d{2}(?:\d{2})?)$/;
  private static iso8601Regex = /^([\+-]?\d{4}(?!\d{2}\b))((-?)((0[1-9]|1[0-2])(\3([12]\d|0[1-9]|3[01]))?|W([0-4]\d|5[0-2])(-?[1-7])?|(00[1-9]|0[1-9]\d|[12]\d{2}|3([0-5]\d|6[1-6])))([T\s]((([01]\d|2[0-3])((:?)[0-5]\d)?|24\:?00)([\.,]\d+(?!:))?)?(\17[0-5]\d([\.,]\d+)?)?([zZ]|([\+-])([01]\d|2[0-3]):?([0-5]\d)?)?)?)?$/;

  public static dateStringIsValid = (dateString: string) => {
    return dateString && DateUtility.dateRegex.test(dateString.trim());
  };

  public static dateStringIncludesTime = (dateString: string) => {
    return dateString && DateUtility.dateTimeOnlyRegex.test(dateString.trim());
  };

  public static getStringFromDate = (date: Date, includeTime?: boolean) => {
    if (!date || !(date instanceof Date) || isNaN(date.getDate())) {
      return "";
    }

    return includeTime
      ? moment(date).format("MM/DD/YYYY h:mm A")
      : moment(date).format("MM/DD/YYYY");
  };

  public static getStringFromInput = (date: any, includeTime?: boolean) => {
    if (!date) {
      return "";
    }

    if (date instanceof Date) {
      return DateUtility.getStringFromDate(date, includeTime);
    }

    if (DateUtility.iso8601Regex.test(date.trim())) {
      return DateUtility.getStringFromDate(moment(date).toDate(), includeTime);
    }

    return "";
  };

  public static getDateFromString = (dateString: string) => {
    if (!DateUtility.dateStringIsValid(dateString)) return null;

    var includesTime = DateUtility.dateStringIncludesTime(dateString.trim());
    var matches = DateUtility.dateRegex.exec(dateString.trim());

    var months = Number(matches[1]);
    var days = Number(matches[2]);
    var years = Number(matches[3]);
    var hours = includesTime ? Number(matches[4]) : 0;
    var minutes = includesTime ? Number(matches[5]) : 0;
    var amOrPm = matches[6];

    if (includesTime && amOrPm === "PM") {
      hours = hours === 12 ? 12 : hours + 12;
    } else if (includesTime && amOrPm === "AM") {
      hours = hours === 12 ? 0 : hours;
    }

    if (years < 100) {
      years += 2000;
    }

    return new Date(years, months - 1, days, hours, minutes);
  };
}
